import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from "../../services/api.service";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  showLoginCard: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService) { }

  eMail: string;

  password: string;

  success: string;

  error: string;

  target: string;

  secret: string;

  isSubmitted: boolean = false;

  fieldTextType: boolean = false;

  ngOnInit() {
    if (this.api.isUserLoggedIn) {
      console.log('Logged in');
    }

    if (this.router.url.includes('/auto-login')) {
      this.showLoginCard = false;
      this.route.queryParams.subscribe(params => {
        if (params && params.email && params.pass) {
          this.eMail = params.email;
          this.password = params.pass;

          this.submit()
        }
        else {
          this.router.navigate(['/login']);
        }
      })
    }

    this.route.queryParams
      .subscribe(params => {
        if (params.target) {
          var uri = decodeURI(params.target);
          console.log(uri);
          this.target = uri;
        }

        if (params.secret) {
          this.secret = params.secret;
        }

      });
  }

  submit() {
    this.error = "";
    this.success = "";

    if (!this.password && !this.eMail) {
      this.error = "Bitte geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein";
      return;
    }

    if (!this.password) {
      this.error = "Bitte geben Sie Ihr Passwort ein";
      return;
    }

    if (!this.eMail) {
      this.error = "Bitte geben Sie Ihre E-Mail-Adresse ein";
      return;
    }

    this.isSubmitted = true;

    this.api.login(this.eMail, this.password).subscribe(
      (data: any) => {
        console.log(data);
        if (data.Succeeded) {
          if (!data.ForceResetPassword) {
            //call change password 
            this.force_change_password();
          }
          else {
            if (!this.secret) {
              this.navigate();
            }
            else {
              var arg = {
                Secret: this.secret
              };

              this.api.post("account/merge", arg).subscribe(
                d => {
                  this.navigate();
                },
                error => {
                  this.error = "Die Einladung konnte nicht zur Shortlist umgeschrieben werden. Bitte wenden Sie sich an engidesk.";
                })
            }
          }
        }
        else {
          this.error = data.Error;
          if (this.showLoginCard === false) {
            this.router.navigate(['/login']);
          }
        }

        this.isSubmitted = false;
      },
      error => {
        this.isSubmitted = false;
        console.log(error);
        if (error.message)
          this.error = error.message;
        else
          this.error = "Ein Fehler ist aufgetreten";

        if (this.showLoginCard === false) {
          this.router.navigate(['/login']);
        }
      });
  }

  navigate() {
    if (!this.target) {
      this.target = '/frame/dashboards';
    }
    this.router.navigateByUrl(this.target);
  }

  force_change_password() {
    if (!this.target) {
      this.target = '/change-password';
    }
    this.router.navigateByUrl(this.target);
  }

  toogleFieldTextTytpe() {
    this.fieldTextType = !this.fieldTextType;
  }

}

